import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["height", "width"]
const _hoisted_2 = ["d", "fill"]

import {computed} from "vue";
import {icons} from "./extends"


export default /*@__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
  icon: {
    type: String,
    required: true,
  },
  height: {
    type: String,
  },
  width: {
    type: String,
  },
  verticalAlign: {
    type: String,
    default: 'middle'
  },
  color: {
    type: String,
  }
},
  setup(__props) {

const props = __props

const svg = computed(()=>{
  return icons.find(item=>item.icon === props.icon)
})

const getFill = (i: number) =>{
  if (props.color)
    return props.color
  return svg.value.fills[i] || '#544f4f'
}


return (_ctx: any,_cache: any) => {
  return (svg.value)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        height: __props.height,
        viewBox: "0 0 1024 1024",
        width: __props.width,
        class: "icon",
        style: _normalizeStyle({verticalAlign: __props.verticalAlign})
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(svg.value.paths, (p, i) => {
          return (_openBlock(), _createElementBlock("path", {
            d: p,
            fill: getFill(i),
            key: i
          }, null, 8, _hoisted_2))
        }), 128))
      ], 12, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})